import { SEARCHFILTER, STATUSCHANGED } from "./actionType";
import initalState from "./initialState";

const filterReducer = (state = initalState, action) => {
  switch (action.type) {
    case STATUSCHANGED:
      return {
        ...state,
        status: action.payload,
      };

    case SEARCHFILTER:
      return {
        ...state,
        search: action.payload,
      };
    default:
      return state;
  }
};

export default filterReducer;
